import { CreateElement } from '@src/vue'
import { Component } from 'vue-property-decorator'
import { Button, MenuButton } from '@src/elements/button/button'
import { Popover } from '@src/components/popover/popover'
import { OptionGroup } from '@src/elements/select/option-group'

import { WorkoutType } from '@src/data/workout-data'
import { ActiveTrainingsWorkouts } from '@src/routes/members/components/active-trainings-workouts/active-trainings-workouts'
import { MemberProfile } from '@src/data/member-profile'
import { Subtitle1 } from '@src/elements/typography/typography'
import { Spacer } from '@src/elements/spacer/spacer'
import { ActivateTrainingPlans } from '@src/routes/members/components/active-trainings-workouts/active-section/activate-training-plans'
import { ActivateWorkouts } from '@src/routes/members/components/active-trainings-workouts/active-section/activate-workouts'
import { WorkoutCardInfo } from '@src/components/card/workout-card/workout-card-info/workout-card-info'
import { TrainingCardInfo } from '@src/components/card/training-card/training-card-info/training-card-info'
import { ActiveTrainingWorkout } from '@src/routes/members/components/active-trainings-workouts/active-section/active-training-workout'
import { Loader } from '@src/components/loading-screen/loader/loader'
import { MIN_LANDSCAPE_WIDTH } from '@src/util/constants'
import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'

type currentWorkoutType = {
  workout: {
    id: number,
    name: string,
    type: string,
    exercise_count: number,
    estimated_duration_in_min: number
  }
}

@Component({
  computed: {
    member () {
      return this.$store.state.memberProfile
    }
  }
})
export class MemberActiveTrainingsWorkouts extends ActiveTrainingsWorkouts {

  protected member: MemberProfile

  private portraitMatch: any

  private apiClient: ApiClient

  private currentWorkoutId: number

  async created (): Promise<void> {
    this.portraitMatch = window.matchMedia('(orientation: portrait)')
    this.portraitMatch.addEventListener('change', this.forceRerender)
    this.apiClient = new ApiClient()
    await this.setCurrentWorkoutId()
    return new Promise<void>((resolve, reject) => {
      resolve()
    })
  }
  beforeDestroy () {
    this.portraitMatch.removeEventListener('change', this.forceRerender)
  }

  forceRerender () {
    this.$forceUpdate()
  }

  async setCurrentWorkoutId () {
    if (this.currentWorkoutId) return
    await this.apiClient.get(API.MEMBERS_API.CURRENT_WORKOUT_STATION, {}, {}).then((response: currentWorkoutType) => {
      this.currentWorkoutId = response.workout.id
    })
  }

  setDocumentTitle () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('PAGE.MEMBERS.DETAIL.TABS.TRAINING')}`
  }

  goToWorkoutPlayGround () {
    const route = `/members/${this.member.id}/training/workout-play-ground/${this.member.activeWorkout.id}`
    this.$router.push(route)
  }

  goToTrainingPlanWorkoutPlayGround () {
    if (!this.currentWorkoutId) {
      this.setCurrentWorkoutId().then(() => {
        const route = `/members/${this.member.id}/training/workout-play-ground/${this.currentWorkoutId}`
        this.$router.push(route)
      }).catch()
    } else {
      const route = `/members/${this.member.id}/training/workout-play-ground/${this.currentWorkoutId}`
      this.$router.push(route)
    }
  }

  render (h: CreateElement) {
    let activeWorkout = this.member.activeWorkout && !this.member.currentTrainingPlan
    let activeTrainingPlan = this.member.currentTrainingPlan

    return <div class='active-trainings-workouts scroll-content' ref='printContainer'>
      {this.renderCreateOptions(h)}
      <div class='mobile-unsupported-message'>
        <div>{this.$t('PAGE.CONTENT.BUILDER.UNSUPPORTED')}</div>
      </div>
      <div class='subtitleWrapper'>
        <div class={'dot ' + (activeWorkout ? 'active' : 'inactive')}/>
        <Subtitle1>{this.$t('PAGE.MEMBERS.TRAINING.ACTIVE_STATION_WORKOUT')}</Subtitle1>
      </div>
      <ActiveTrainingWorkout title='PAGE.MEMBERS.TRAINING.SET_ACTIVE_WORKOUT'
                             noSelectionPlaceholder='PAGE.MEMBERS.TRAINING.NO_WORKOUT'
                             content={<ActivateWorkouts type='custom' disableCreate={!this.member.memberPermissions.createStationWorkout} allowAllWorkouts={this.member.memberPermissions.changeActiveStationWorkout} />}
                             activeItem={this.member.activeWorkout ?
                               <WorkoutCardInfo workout={this.member.activeWorkout} type='active' member={this.member}
                                                readonly={!this.member.memberPermissions.createStationWorkout} /> : null}
                             type='custom' />
      {this.member.activeWorkout && (this.member.memberPermissions.changeIndividualStationWorkout || this.member.memberPermissions.changeActiveStationWorkout) ?
        <div class='active-workout-button-wrapper'>
          <Button class='start-workout' type='outline' label={this.getDeviceTranslationForActiveWorkoutButtons('START_WORKOUT')} click={
            () => this.goToWorkoutPlayGround()}/>
          <Button type='elevated' label={this.getDeviceTranslationForActiveWorkoutButtons('PAGE.MEMBERS.TRAINING.CHANGE_WORKOUT')} click={
            () => this.changeSelection('custom', this.member.activeWorkout)}/>
        </div> :
        this.member.activeWorkout ? <div class='active-workout-button-wrapper'>
          <Button class='start-workout' type='outline' label={this.getDeviceTranslationForActiveWorkoutButtons('START_WORKOUT')} click={
            () => this.goToWorkoutPlayGround()}/>
        </div> : ''
        }
      <Spacer />
      <Spacer />

      {/*Hide home workouts*/}
      {/*<Subtitle1>{this.$t('PAGE.MEMBERS.TRAINING.ACTIVE_HOME_WORKOUT')}</Subtitle1>*/}
      {/*<ActiveTrainingWorkout title='PAGE.MEMBERS.TRAINING.SET_ACTIVE_WORKOUT'*/}
      {/*                       noSelectionPlaceholder='PAGE.MEMBERS.TRAINING.NO_WORKOUT'*/}
      {/*                       content={<ActivateWorkouts type='home' />}*/}
      {/*                       activeItem={this.member.homeWorkout ?*/}
      {/*                         <WorkoutCardInfo workout={this.member.homeWorkout} type='active'*/}
      {/*                                          readonly={!this.member.memberPermissions.changeActiveHomeWorkout} /> : null}*/}
      {/*                       type='home' />*/}
      {/*{this.member.homeWorkout && this.member.memberPermissions.changeActiveHomeWorkout ?*/}
      {/*  <Button class='change-workout' type='elevated' label={this.$t('PAGE.MEMBERS.TRAINING.CHANGE_WORKOUT')} click={*/}
      {/*    () => this.changeSelection('home', this.member.homeWorkout)} /> :*/}
      {/*  ''}*/}
      {/*<Spacer />*/}
      {/*<Spacer />*/}
      <div class='subtitleWrapper'>
        <div class={'dot ' + (activeTrainingPlan ? 'active' : 'inactive')}/>
        <Subtitle1>{this.$t('PAGE.MEMBERS.TRAINING.ACTIVE_TRAINING_PLAN')}</Subtitle1>
      </div>
      <ActiveTrainingWorkout title='PAGE.MEMBERS.TRAINING.SET_ACTIVE_TRAINING_PLAN'
                             noSelectionPlaceholder='PAGE.MEMBERS.TRAINING.NO_TRAINING_PLAN'
                             content={<ActivateTrainingPlans disableCreate={!this.member.memberPermissions.createTrainingPlan} allowAllPlans={this.member.memberPermissions.changeActiveTrainingPlan}/>}
                             activeItem={this.member.currentTrainingPlan ? <TrainingCardInfo type='active' training={this.member.currentTrainingPlan}/> : null}
                             type='training-plan'
                             class='active-training-plan-wrapper' />
      {this.member.currentTrainingPlan && (this.member.memberPermissions.changeIndividualTrainingPlan || this.member.memberPermissions.changeActiveTrainingPlan) ?
        <div class='active-workout-button-wrapper'>
          <Button class='start-workout' type='outline'
                  label={this.getDeviceTranslationForActiveWorkoutButtons('START_WORKOUT')} click={
            () => this.goToTrainingPlanWorkoutPlayGround()}/>
          <Button class='change-workout' type='elevated' label={this.getDeviceTranslationForActiveWorkoutButtons('PAGE.MEMBERS.TRAINING.CHANGE_PLAN')} click={
            () => this.changeSelection('training-plan', this.member.currentTrainingPlan)} />
        </div> :
        this.member.currentTrainingPlan ? <div class='active-workout-button-wrapper'>
          <Button class='start-workout' type='outline' label={this.getDeviceTranslationForActiveWorkoutButtons('START_WORKOUT')} click={
            () => this.goToTrainingPlanWorkoutPlayGround()}/>
        </div> : ''}
      <Spacer />
      {this.loading && <Loader/>}
      {this.renderUpcomingTPS(h)}
    </div>
  }

  renderCreateOptions (h: CreateElement) {
    const allowCreateStationWorkout = this.member.memberPermissions.createStationWorkout && this.member.memberPermissions.changeActiveStationWorkout
    // const allowCreateHomeWorkout = this.member.memberPermissions.createHomeWorkout && this.member.memberPermissions.changeActiveHomeWorkout
    const allowCreateTrainingPlan = this.member.memberPermissions.createTrainingPlan && this.member.memberPermissions.changeActiveTrainingPlan

    if (!allowCreateStationWorkout /*&& !allowCreateHomeWorkout*/ && !allowCreateTrainingPlan) {
      return null
    }

    return <MenuButton class='workout-btn'>
      <Button slot='button' label={this.$t('NEW')} type='elevated' />
      <Popover>
        <OptionGroup>
          {allowCreateStationWorkout ?
            <div onClick={() => {
              this.goToWorkoutBuilder(WorkoutType.CUSTOM)
            }}>{this.$t('PAGE.MEMBERS.TRAINING.ACTIVE_STATION_WORKOUT')}</div> : null}
          {/*Hide home workouts*/}
          {/*{allowCreateHomeWorkout ?*/}
          {/*  <div onClick={() => {*/}
          {/*    this.goToWorkoutBuilder(WorkoutType.HOME)*/}
          {/*  }}>{this.$t('PAGE.MEMBERS.TRAINING.ACTIVE_HOME_WORKOUT')}</div> : null}*/}
          {allowCreateTrainingPlan ?
            <div onClick={this.goToTrainingPlanBuilder}>{this.$t('PAGE.MEMBERS.TRAINING.ACTIVE_TRAINING_PLAN')}</div> : null}
        </OptionGroup>
      </Popover>
    </MenuButton>
  }

  private getDeviceTranslationForActiveWorkoutButtons (key) {
    if (window.innerWidth <= MIN_LANDSCAPE_WIDTH) return this.$t(`${key}_MOBILE`)
    return this.$t(`${key}`)
  }
}
